import type { ContractStatus } from '@vy/types';
import { ContractStatusSchema } from '@vy/types';
import { useStateParams } from '../../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../../utils/params-formatting';

export function useContractStatusesParam(defaultValue: ContractStatus[] = []) {
  return useStateParams<ContractStatus[]>(
    defaultValue,
    'contractStatuses',
    serializeStringArrayParam,
    deserializeContractStatusArrayParam,
  );
}

function deserializeContractStatusArrayParam(
  contractStatusesArrayStringified: string,
): ContractStatus[] | null {
  const statuses = contractStatusesArrayStringified.split(',');

  return statuses.map((status) => ContractStatusSchema.parse(status));
}
